import React, { useEffect } from 'react';
import './ReasonsWhy.scss';

const ReasonsWhy = () => {
  useEffect(() => {
    const reasons = document.querySelectorAll('.reason'); // Cache elements

    const handleScroll = () => {
      reasons.forEach(reason => {
        const rect = reason.getBoundingClientRect();
        if (rect.top < window.innerHeight) {
          reason.classList.add('visible');
        }
      });
    };

    const debounceScroll = () => {
      let timeout;
      return () => {
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(() => {
          handleScroll();
        }, 100); // Adjust debounce time as necessary
      };
    };

    const debouncedHandleScroll = debounceScroll();
    window.addEventListener('scroll', debouncedHandleScroll);
    handleScroll(); // Trigger the function on component mount

    return () => {
      window.removeEventListener('scroll', debouncedHandleScroll);
    };
  }, []);

  return (
    <div className="reasons-why">
      <h1>Your Top Choice For Sales And Lettings</h1>
      <div className="reasons-container">
        <div className="reason">
          <img 
            loading="lazy" 
            src="https://firebasestorage.googleapis.com/v0/b/content-filter-154e4.appspot.com/o/assets%2Fpound-icon-.png?alt=media&token=8e006fd7-f62d-47a8-a521-911cf854397b" 
            alt="Expert Valuations" 
          />
          <h3>Expert Valuations</h3>
          <p>Our in person and online property valuations ensure you get the highest possible price for your property, backed by years of experience and market knowledge.</p>
        </div>
        <div className="reason">
          <img 
            loading="lazy" 
            src="https://firebasestorage.googleapis.com/v0/b/content-filter-154e4.appspot.com/o/assets%2Fhands-icon-smooth.png?alt=media&token=3a4b0852-1f10-4f92-986a-4185e50babb8" 
            alt="Trusted Reviews" 
          />
          <h3>Excellent Reviews</h3>
          <p>With over 30,000 reviews rating us excellent, you can be confident in our reputation and commitment to exceptional service.</p>
        </div>
        <div className="reason">
          <img 
            loading="lazy" 
            src="https://firebasestorage.googleapis.com/v0/b/content-filter-154e4.appspot.com/o/assets%2Fpersonalised-touch-smooth.png?alt=media&token=29b00796-22dc-42f8-80dd-aefce9b330a2" 
            alt="Personalized Service" 
          />
          <h3>Personalised Service</h3>
          <p>Our dedicated staff are always attentive to your needs, offering personalised service to guide you through every step of your property journey.</p>
        </div>
      </div>
    </div>
  );
};

export default ReasonsWhy;
